
import './ProfileFormEditContainer.scss';
export default function ProfileFormEditContainer(props: any) {
    return (
        <div className="sc-hkHFWD fCkTrG ">{props.children}</div>
    );
}